/** @format */

import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  CssBaseline,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import { format, compareAsc } from "date-fns";
import UserContext from "../../context/Globales/UserContext";

//import InformeRessult from './InformeRessult';
import Identificacion from "./Identificacion";
import IndicadoresPositivoNegativo from "./IndicadoresPositivoNegativo";
import IndicadoresEmpresas from "./IndicadoresEmpresas";
import AsignacionGraficos from "./AsignacionGraficos";
import AsignacionTable from "./AsignacionTable";

import { globales, mensajeglobales } from "../../helpers/Confi";
import TblEstructuraFinanciera from "./TblEstructuraFinanciera";
import Alert from "@material-ui/lab/Alert";
import { AlertTitle } from "@material-ui/lab";
import Loading from "../modales/Loading";
import { DecodificanString } from "../../helpers/Codifican";

const ViewInforme = () => {
  const ref = React.createRef();
  const [existDeudaSuper, setExistDeudaSuper] = useState(false);
  const productos = JSON.parse(DecodificanString(localStorage.getItem("prods")));
  const productValidation = JSON.parse(
    localStorage.getItem("productvalidation")
  );

  const { datoIC, statOkLoading, codeError } = useContext(UserContext);
  const navigate = useHistory();
  const parametros = globales(); //  parametros globales:

  useEffect(() => {
    if (datoIC && datoIC.length === 0) {
      navigate.push("/informe");
    }
  }, []);

  useEffect(() => {
    if (productos.data && productos.data.length > 0) {
      const existProd = productos.data.filter( x => x.Id === 0);
      if (existProd && existProd.length > 0 && existProd[0].Vigente === true) {
        setExistDeudaSuper(true)
      } else {
        setExistDeudaSuper(false)
      }
    }
  }, [productos])

  const NewConsult = () => {
    navigate.push("/informe");
  };
  /*   console.log(datoIC, statOkLoading ? "isTrue" : "isFalse"); */

  /*   const AlertSinResult = (
    <>
      <Card>
        <CardContent>
          {datoIC && datoIC.ID == null && datoIC.Identificacion?.Nombre == null ? (
            "  "
          ) : (
            <img
              src={
                process.env.PUBLIC_URL + "/static/imagen/algo-ha-salido-mal.png"
              }
              width="30%"
              title="Imagen algo a salido mal"
              alt="algo a salido mal"
            ></img>
          )}
          <br />
          {datoIC.ID == null && datoIC.Identificacion?.Nombre == null ? (
            <h1>Redireccionado... </h1>
          ) : (
            <h1>ATENCIÓN </h1>
          )}
          <Divider />
          {datoIC.ID == null && datoIC.Identificacion?.Nombre == null ? (
            " "
          ) : (
            <p>
              No se pudo procesar la solicitud, INTENTE DE NUEVO - SI EL
              PROBLEMA PERSISTE CONTACTE A SOPORTE
            </p>
          )}
         
          {datoIC.ID == null && datoIC.Identificacion?.Nombre == null ? (
            ""
          ) : (
            <Button variant="contained" color="primary" onClick={NewConsult}>
              Consultar de Nuevo
            </Button>
          )}{" "}
          <br />
        </CardContent>
      </Card>
    </>
  ); */

  const error500 = (
    <div
      style={{
        textAlign: "center",
        alignContent: "center",
        padding: "150px",
        width: "100%",
      }}
    >
      <Card>
        <CardContent>
          <img
            src={
              process.env.PUBLIC_URL + "/static/imagen/algo-ha-salido-mal.png"
            }
            width="30%"
            title="Imagen algo a salido mal"
            alt="Sin conexíon a internet"
          ></img>
          <h1>Antención no tuvimos respuesta con su solicitud</h1>
          <Divider />
          <p>Recomendamos que Cierre Sesión e intentente de nuevo</p>

          <br />
          {/* <Button
        variant="contained"
        color="primary"
        onClick={comprobarInternet}
      >
        Reintentar
      </Button> */}
        </CardContent>
      </Card>
    </div>
  );

  return (
    <>
      <CssBaseline />
      {codeError === 500 ? error500 : ""}

      {datoIC == null && statOkLoading ? (
        <div
          className="container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "15em",
          }}
        >
          <Loading />
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
              <Card>
                <CardContent>
                  <Typography variant="h5" color="primary">
                    Espere estamos procesando la información...
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      ) : (
        ""
      )}
      {datoIC && !statOkLoading ? (
        <div className="container">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
              <Identificacion />
            </Grid>

            <br />
            <Grid item xs={12} sm={12} xl={8} md={8} lg={8}>
              <IndicadoresPositivoNegativo />

              <AsignacionGraficos />

              <br />
              <AsignacionTable />
              <br />
            </Grid>

            {productValidation === true && existDeudaSuper === true ? (
              <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                <TblEstructuraFinanciera />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </div>
      ) : (
        " "
      )}
    </>
  );
};

export default ViewInforme;
